import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ContactRolesFetchFailedAction = {
	type: 'CONTACT_ROLES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ContactRolesFetchFailedAction => ({
	type: 'CONTACT_ROLES_FETCH_FAILED',
	payload,
});
